import { Hub } from 'interfaces/hub'

export type HubParams = { id: Hub['id'] }

export const getHub = ({ id }: HubParams) => {
  return {
    url: `/api/hubs/${id}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}
